import { createStore, RequestStatus } from "common-frontend-components";
const { get, set, useStore, fetchStore } = createStore({ getDefaultValues: () => ({
        data: [],
        mapById: {},
        mapBySitePhotoId: {},
        mapByGroupName: {},
        status: RequestStatus.pending,
    }) });
export const sitePhotoGroupStore = {
    getData: () => get().data,
    getMapById: () => get().mapById,
    getMapBySitePhotoId: () => get().mapBySitePhotoId,
    getMapByGroupName: () => get().mapByGroupName,
    getGroupsBySitePhotoId: (id) => get().mapBySitePhotoId[id] || [],
    setData: (data) => {
        set({
            data,
            mapById: data.reduce((map, item) => (map[item.id] = item, map), {}),
            mapBySitePhotoId: data.reduce((map, item) => {
                if (map[item.sitePhotoId] === undefined)
                    map[item.sitePhotoId] = [];
                map[item.sitePhotoId].push(item);
                return map;
            }, {}),
            mapByGroupName: data.reduce((map, item) => {
                if (map[item.group] === undefined)
                    map[item.group] = [];
                map[item.group].push(item);
                return map;
            }, {}),
        });
    },
    useData: () => useStore(fetchStore.data),
    useDataBySitePhotoId: (sitePhotoId) => useStore(s => s.mapBySitePhotoId[sitePhotoId]),
    useDataByGroupName: (groupName) => useStore(s => s.mapByGroupName[groupName]),
    getStatus: () => get().status,
    setStatus: (status) => set({ status }),
    useStatus: () => useStore(fetchStore.status),
    useGroupsBySitePhotoId: (id) => useStore(s => s.mapBySitePhotoId[id]) || [],
};
//# sourceMappingURL=sitePhotoGroupStore.js.map